<template>
  <div class="bottom1">
    <a style="color:gray;" target="_blank" href="https://beian.miit.gov.cn/">京ICP备2024066658号</a> 智步云上 版权所有
  </div>
</template>

<script>

export default {
  name: 'Footer',
  components: {},

  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.bottom1 {
  display: block;
  float: left;
  width: 100%;
  height: 30px;
  background: gainsboro;
  text-align: center;
  line-height: 30px;
  color: gray;
  font-size: 12px;
}
</style>
